export default function About() {
  return (
    <section className="section about" id="about">
      <div className="section-wrap about__layout">
        <div>
          <p className="eyebrow">A little about me</p>
          <h2>Hi, I’m Colin.</h2>
        </div>
        <div className="about__copy">
          <p className="about__lead">
            I’m a software engineer who enjoys turning everyday friction into
            clear, useful applications.
          </p>
          <p>
            My project work spans artist commission management, time reporting,
            maintenance tracking, and AI-assisted tools. I like working across
            the full product—interface, application logic, data, and deployment—
            so the pieces fit together.
          </p>
          <div className="about__links">
            <a className="text-link" href="https://github.com/Boomup25" target="_blank" rel="noopener noreferrer">
              GitHub <span aria-hidden="true">↗</span>
            </a>
            <a className="text-link" href="https://www.linkedin.com/in/colin-h-23007a279/" target="_blank" rel="noopener noreferrer">
              LinkedIn <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
